// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".operation[data-v-1159acff]  .el-button {\n  padding: 0 !important;\n}\n.cell .el-tag.el-tag--info[data-v-1159acff] {\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
